import { render } from "./base-modal-confirmation.vue?vue&type=template&id=657ed584"
import script from "./base-modal-confirmation.vue?vue&type=script&lang=js"
export * from "./base-modal-confirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__